import React from "react";
import AddCredit from "../components/addcredit";
import RightMenu from "../components/widgets/offcanvas";
import { useSelector, useDispatch } from "react-redux";
import { RightOffClear } from "../redux/slices/offcanvas";
import GetUserDatas from "../components/widgets/user";
export function AddcreditPage(read) {
  const dispatch = useDispatch();
  const datas = useSelector((v) => v.rtl);

  return (
    <div>
      <AddCredit read={read} />
      <RightMenu
        children={<GetUserDatas />}
        status={datas?.status}
        read={read}
        close={() => dispatch(RightOffClear())}
      />
    </div>
  );
}

export default AddcreditPage;
